export default __webpack_public_path__ + "static/about_us-b43dbbd8d04190ca433f0248bd22e474.png";